import React from 'react';
import styles from './Profile.module.scss'
import {useNavigate} from "react-router-dom";
import useRandomAvatar from "../../../../hooks/useRandomAvatar";
import {useSelector} from "react-redux";

const Profile = () => {
    const {avatar} = useRandomAvatar();
    const navigate = useNavigate();
    const {profile, loading} = useSelector((state) => state.profile);

    const handleClick = () => {
        navigate('/account');
    }

    return (
        <div className={styles.profile} onClick={handleClick}>
            {loading ? (
                <p></p>
            ) : profile ? (
                <div className={styles.profile}>
                    <img className={styles.avatar} src={avatar} alt="avatar" />
                    <p>{profile.name}</p>
                </div>
            ) : (
                <p></p>
            )}
        </div>
    );
};

export default Profile;
